<template>

    <form ref="candidato-form-reiniciar-teste" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="teste.dtInicio">Tem certeza que deseja reiniciar o teste?</label>
            </div>
            <div class="col-md-12">
                <div class="alert alert-info">
                    Ao clicar em REINICIAR, todas as respostas serão apagadas e um novo teste será gerado.
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Reiniciar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "candidato-form-reiniciar-teste",
        mixins: [base],
        props: { id: Number, cpf: String },
        data: () => ({

            model: {
                teste: {}
            },

            form: "candidato-form-reiniciar-teste",

            resources: {
                edit: 'candidato',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                model.attributeBehavior = "ReiniciarTeste";
                model.candidatoId = this.id;

                this.showLoading();

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Teste reiniciado com sucesso.");
                    this.$emit('on-saved', data.data)
                }, err => {
                    this.defaultErrorResult(err);
                })

            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() { }
    };
</script>